Ext.define('SA.view.Notification', {
    alias: 'widget.notification',
    extend: 'SA.view.PromptWindow',

    cls: 'sa-notification',
    includeCloseBtn: false,
    includeHeader: true,
    includeOkBtn: true,

    getBodyItems() {
        return {xtype: 'component', html: this.messageHtml};
    }
});